export default __webpack_public_path__ + "static/media/gileadstats.c7b174bd.svg";